import React, {useEffect, useMemo} from 'react';
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import * as actions from '../../../_redux/investigations/investigationsActions';
import {Modal} from "react-bootstrap";
import {ModalProgressBar} from "../../../../../../_metronic/_partials/controls";
import {useInvestigationsUIContext} from "../InvestigationsUIContext";

export function InvestigationDeleteDialog({id, show, onHide}) {
    const investigationsUIContext = useInvestigationsUIContext();
    const investigationsUIProps = useMemo(() => {
        return {
            setIds: investigationsUIContext.setIds,
            queryParams: investigationsUIContext.queryParams
        }
    }, [investigationsUIContext]);


    const dispatch = useDispatch();
    const {isLoading} = useSelector(
        (state) => ({isLoading: state.investigations.actionsLoading}),
        shallowEqual
    );

    useEffect(() => {
        if (!id)
            onHide();
    }, [id]);

    useEffect(() => {}, [isLoading, dispatch]);

    const deleteInvestigation = () => {
        dispatch(actions.deleteInvestigation(id)).then(() => {
            dispatch(actions.fetchInvestigations(investigationsUIProps.queryParams));

            investigationsUIProps.setIds([]);

            onHide();
        })
    }


    return(
        <Modal
            show={show}
            onHide={onHide}
        >
            {isLoading && <ModalProgressBar variant={"query"}/> }

            <Modal.Header closeButton>
                <Modal.Title>
                    حذف بازرسی
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {!isLoading && (
                    <span>آیا از حذف بازرسی انتخاب شده مطمئن هستید؟</span>
                )}
                {isLoading && <span>در حال حذف بازرسی...</span>}
            </Modal.Body>
            <Modal.Footer>
                <div>
                    <button
                        type="button"
                        onClick={onHide}
                        className="btn btn-light btn-elevate"
                    >
                        لغو
                    </button>
                    <> </>
                    <button
                        type="button"
                        onClick={deleteInvestigation}
                        className="btn btn-delete btn-elevate"
                    >
                        تایید
                    </button>
                </div>
            </Modal.Footer>
        </Modal>
    )
}